import { useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Drawer } from "cerulean";

import { entities } from "byzantine";

import MerchantDetails from "../MerchantDetails";

const MerchantDetailsDrawer = ({ cardId }: { cardId: API.CardId }) => {
  const { transactionUuid } = useParams<{
    transactionUuid?: string;
  }>();
  const navigate = useNavigate();
  const handleDrawerClose = useCallback(
    () => navigate(`/cards/${cardId}/subscriptions`, { replace: true }),
    [cardId, navigate]
  );

  const transaction = entities.subscriptions.useTransactionByUuid(
    cardId,
    transactionUuid || ""
  );

  if (!transactionUuid || !transaction) {
    return null;
  }

  return (
    <Drawer
      depth="470px"
      isOpen={true}
      onUserDismiss={handleDrawerClose}
      showControls={false}
      paddingSize="none"
    >
      <MerchantDetails cardId={cardId} transactionUuid={transactionUuid} />
    </Drawer>
  );
};

export default MerchantDetailsDrawer;
